// extracted by mini-css-extract-plugin
export default {"pagination":"CustomPagination_pagination__3feqX","active_container":"CustomPagination_active_container__KvINm"};